module.exports = __webpack_public_path__ + "img/world.09173cd6.png";